  
import uploadFile from './direct_upload'

async function direct_upload_file(one_file){
  try {
    let sign = ''
    
    let blob = await uploadFile(one_file)
    sign = blob.signed_id
    // console.log({sign});
    return sign
  } catch (error) {
    console.log({error});
    throw error
  }
}

export default direct_upload_file